import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SignaturePad from '../components/SignaturePad';
import Swal from 'sweetalert2';
import '../styles/HptScreens.css';

const API_URL = process.env.REACT_APP_API_URL;

const DEPARTAMENTOS_861 = [
    { label: 'Operación', valor: 'OPERACION' },
    { label: 'Mantenimiento - Mecánico', valor: 'MECANICO' },
    { label: 'Mantenimiento - Eléctrico', valor: 'ELECTRICOS' },
    { label: 'Mantenimiento - Instrumentación', valor: 'INSTRUMENTACION' },
    { label: 'Mantenimiento - Campo Solar', valor: 'CAMPO SOLAR' },
    { label: 'Mantenimiento - Químico', valor: 'QUIMICO' },
    { label: 'PRL', valor: 'PRL' },
    { label: 'Genérico Planta', valor: 'GENERICO PLANTA' }
];

const DEPARTAMENTOS_579 = [
    { label: '00200', valor: 'PARQUE EÓLICO GECAMA' },
    { label: '00500', valor: 'PSFV LAS MOTILLAS' },
    { label: '00600', valor: 'PSFV LA REVUELTA' },
    { label: '00800', valor: 'PSFV ICTIO SOLAR' },
    { label: '00900', valor: 'PSFV ESTRELLA SOLAR' },
    { label: '01100', valor: 'PSFV ROCINANTE' },
    { label: '01200', valor: 'SOLARIA' },
    { label: '01201', valor: 'BELINCHÓN' },
    { label: '01203', valor: 'CASTOR' },
    { label: '01205', valor: 'AÑOVER' },
    { label: '01300', valor: 'SOLARIAA' },
    { label: '01400', valor: 'CLUSTER CALATRAVA' },
    { label: 'PRL', valor: 'PRL' },
    { label: 'Genérico Planta', valor: 'GENERICO PLANTA' }
];

const TIPOS_SOLICITUD = [
    { id: 'REPUESTOS', label: 'REPUESTOS (Requiere Nº de OT y Planta)' },
    { id: 'CONSUMIBLES', label: 'CONSUMIBLES (Petición agrupada taller - Stock < 20%)' },
    { id: 'HERRAMIENTAS', label: 'HERRAMIENTAS (Reposición semestral: Julio/Enero)' },
    { id: 'HERRAMIENTA_ESPECIFICA', label: 'HERRAMIENTA ESPECÍFICA (Urgente / Uso concreto)' },
    { id: 'MATERIAL_OFICINA', label: 'MATERIAL OFICINA Y SERVICIOS GRALES' },
    { id: 'REPOSICION_EPIS', label: 'REPOSICIÓN STOCKS EPIS' },
    { id: 'OTROS', label: 'OTROS (Especificar en justificación)' }
];

const CreateCompraScreen = () => {
    const navigate = useNavigate();

    const token = localStorage.getItem('userToken');
    let currentUser = {};
    if (token) {
        try {
            currentUser = JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            console.error("Error al decodificar token");
        }
    }

    // Datos de cabecera
    const [departamento, setDepartamento] = useState('');
    const [cp, setCp] = useState('861/862 TERMOSOLARES');
    const [solicitanteSeleccionado, setSolicitanteSeleccionado] = useState(null);
    const [busquedaSolicitante, setBusquedaSolicitante] = useState('');
    const [opcionesSolicitante, setOpcionesSolicitante] = useState([]);
    const [mostrarDropdownSol, setMostrarDropdownSol] = useState(false);

    // Tipo de Solicitud
    const [tipoSolicitud, setTipoSolicitud] = useState('REPUESTOS');

    // Detalles de Materiales (Tabla dinámica)
    const [materiales, setMateriales] = useState([
        { articulo: '', descripcion: '', cantidad: '', ot_referencia: '', planta_destino: '' }
    ]);

    // Justificación
    const [justificacion, setJustificacion] = useState('');

    // Firmas y acciones
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [accionSubmit, setAccionSubmit] = useState('sign');
    const [guardando, setGuardando] = useState(false);

    // Archivos adjuntos
    const [archivosPendientes, setArchivosPendientes] = useState([]);

    const debounceRef = useRef(null);

    // Búsqueda de solicitante
    const handleBuscarSolicitante = (texto) => {
        setBusquedaSolicitante(texto);
        if (debounceRef.current) clearTimeout(debounceRef.current);

        if (texto.trim().length < 2) {
            setOpcionesSolicitante([]);
            return;
        }

        debounceRef.current = setTimeout(async () => {
            try {
                const res = await axios.get(`${API_URL}/api/catalogos/usuarios/buscar?q=${texto}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const soloUsuarios = (res.data.results || []).filter(item => item.tipo === 'USUARIO');
                setOpcionesSolicitante(soloUsuarios);
                setMostrarDropdownSol(true);
            } catch (err) {
                console.error("Error buscando usuarios solicitantes:", err);
            }
        }, 300);
    };

    const handleSeleccionarSolicitante = async (opcion) => {
        setBusquedaSolicitante(opcion.etiqueta);
        setMostrarDropdownSol(false);

        try {
            const res = await axios.get(`${API_URL}/api/catalogos/usuarios`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const usuarioEncontrado = res.data.find(u => u.usuario === opcion.valor);
            if (usuarioEncontrado) {
                setSolicitanteSeleccionado(usuarioEncontrado);
            }
        } catch (error) {
            console.error("Error resolviendo id de usuario:", error);
        }
    };

    // Tabla de materiales
    const handleAddFila = () => {
        setMateriales([...materiales, { articulo: '', descripcion: '', cantidad: '', ot_referencia: '', planta_destino: '' }]);
    };

    const handleRemoveFila = (idx) => {
        if (materiales.length === 1) {
            Swal.fire('Atención', 'La solicitud debe contener al menos un material.', 'warning');
            return;
        }
        setMateriales(materiales.filter((_, i) => i !== idx));
    };

    const handleMaterialChange = (idx, field, val) => {
        const nuevos = [...materiales];
        nuevos[idx][field] = val;
        setMateriales(nuevos);
    };

    // Envío del formulario
    const procesarGuardado = async (firmaBase64 = null) => {
        if (!departamento) {
            return Swal.fire('Campo requerido', 'Por favor selecciona el Taller o Departamento.', 'warning');
        }
        if (!solicitanteSeleccionado) {
            return Swal.fire('Campo requerido', 'Por favor busca y selecciona el Solicitante.', 'warning');
        }

        const filasValidas = materiales.filter(m => m.descripcion.trim() !== '' && m.cantidad.trim() !== '');
        if (filasValidas.length === 0) {
            return Swal.fire('Materiales requeridos', 'Debes especificar al menos un material con descripción y cantidad.', 'warning');
        }

        if ((tipoSolicitud === 'REPUESTOS' || tipoSolicitud === 'HERRAMIENTA_ESPECIFICA') && !justificacion.trim()) {
            return Swal.fire('Justificación obligatoria', 'Para Repuestos o Herramientas Específicas es obligatorio indicar una justificación.', 'warning');
        }

        setGuardando(true);

        const payload = {
            cp,
            departamento,
            id_solicitante: solicitanteSeleccionado.id_usuario,
            tipo_solicitud: tipoSolicitud,
            justificacion: justificacion.trim(),
            materiales: filasValidas
        };

        try {
            const res = await axios.post(`${API_URL}/api/compras`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const nuevoId = res.data.id_solicitud;

            if (archivosPendientes.length > 0) {
                for (const file of archivosPendientes) {
                    const formDataFile = new FormData();
                    formDataFile.append('file', file);
                    await axios.post(`${API_URL}/api/compras/${nuevoId}/subir-archivo`, formDataFile, {
                        headers: { 
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data' 
                        }
                    });
                }
            }

            if (firmaBase64) {
                await axios.post(`${API_URL}/api/compras/${nuevoId}/firmar`, {
                    firma_path: firmaBase64
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }

            Swal.fire({
                title: '¡Solicitud Registrada!',
                text: `Se ha generado la solicitud de compra #${nuevoId}.`,
                icon: 'success',
                confirmButtonColor: '#003366',
                timer: 2000
            }).then(() => {
                navigate('/dashboard');
            });

        } catch (error) {
            setGuardando(false);
            console.error("Error al guardar solicitud:", error);
            Swal.fire('Error', error.response?.data?.error || 'No se pudo procesar la solicitud.', 'error');
        }
    };

    return (
        <div className="container">
            <form onSubmit={(e) => {
                e.preventDefault();
                if (accionSubmit === 'sign') {
                    setShowSignaturePad(true);
                } else {
                    procesarGuardado(null);
                }
            }}>
                {/* Cabecera Principal */}
                <div className="top-header" style={{ borderLeftColor: '#003366' }}>
                    <div className="d-flex align-center">
                        <span className="ptw-label">NUEVA SOLICITUD:</span>
                        <div className="ptw-badge" style={{ backgroundColor: '#003366' }}>
                            📦 COMPRAS Y ALMACÉN
                        </div>
                    </div>
                    <div className="header-actions">
                        <button 
                            type="submit" 
                            disabled={guardando}
                            className="btn-save" 
                            style={{ backgroundColor: '#003366' }}
                            onClick={() => setAccionSubmit('sign')}
                        >
                            ✍️ Proceder a Firma
                        </button>
                        <button 
                            type="submit" 
                            disabled={guardando}
                            className="btn-save" 
                            style={{ backgroundColor: '#455a64' }} 
                            onClick={() => setAccionSubmit('save')}
                        >
                            💾 Guardar sin Firma
                        </button>
                        <button 
                            type="button" 
                            onClick={() => navigate('/dashboard')} 
                            className="btn-close"
                        >
                            Cancelar
                        </button>
                    </div>
                </div>

                {/* 1. DATOS DE LA SOLICITUD */}
                <div className="main-card">
                    <div className="card-header-internal" style={{ color: '#003366' }}>
                        1. Datos de la Solicitud
                    </div>
                    <div className="row">
                        <div className="info-box flex-1">
                            <span className="info-label">FECHA</span>
                            <input 
                                type="text" 
                                readOnly 
                                className="main-input" 
                                value={new Date().toLocaleDateString('es-ES')} 
                                style={{ backgroundColor: '#f0f4f8', fontWeight: 'bold' }}
                            />
                        </div>

                        {/* --- NUEVO SELECTOR DE CP CON PROTECCIÓN --- */}
                        <div className="info-box flex-1">
                            <span className="info-label">CENTRO DE PRODUCCIÓN *</span>
                            <select 
                                required 
                                className="main-select" 
                                value={cp} 
                                onChange={e => {
                                    const nuevoCp = e.target.value;
                                    // Bloqueo: Si elige 579, tiene que ser ADMIN o GESTOR de SOLAR/EOLICO
                                    if (nuevoCp === '579' && currentUser.rol !== 'ADMINISTRADOR' && !(currentUser.rol === 'GESTOR' && ['SOLAR', 'EOLICO'].includes(currentUser.grupo))) {
                                        Swal.fire('Acceso denegado', 'Solo los Gestores de SOLAR o EOLICO pueden crear solicitudes para 579.', 'error');
                                        return;
                                    }
                                    setCp(nuevoCp);
                                    setDepartamento(''); // Reseteamos el departamento al cambiar de CP
                                }}
                            >
                                <option value="861/862 TERMOSOLARES">861/862 TERMOSOLARES</option>
                                <option value="579">579</option>
                            </select>
                        </div>

                        {/* --- SELECTOR DE DEPARTAMENTO (DINÁMICO) --- */}
                        <div className="info-box flex-1">
                            <span className="info-label">TALLER / DEPARTAMENTO *</span>
                            <select 
                                required 
                                className="main-select" 
                                value={departamento} 
                                onChange={e => setDepartamento(e.target.value)}
                            >
                                <option value="">-- Seleccionar --</option>
                                {/* Cargamos una lista u otra dependiendo del CP elegido */}
                                {(cp === '579' ? DEPARTAMENTOS_579 : DEPARTAMENTOS_861).map(d => (
                                    <option key={d.valor} value={d.valor}>{d.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="info-box flex-2 relative">
                            <span className="info-label">SOLICITANTE *</span>
                            <input 
                                type="text"
                                required
                                className="main-input"
                                placeholder="Escribe el nombre del solicitante..."
                                value={busquedaSolicitante}
                                onChange={e => {
                                    handleBuscarSolicitante(e.target.value);
                                    if (solicitanteSeleccionado) setSolicitanteSeleccionado(null);
                                }}
                                onFocus={() => setMostrarDropdownSol(opcionesSolicitante.length > 0)}
                                onBlur={() => setTimeout(() => setMostrarDropdownSol(false), 200)}
                            />
                            {mostrarDropdownSol && opcionesSolicitante.length > 0 && (
                                <ul className="autocomplete-list">
                                    {opcionesSolicitante.map((opc, idx) => (
                                        <li 
                                            key={idx} 
                                            className="autocomplete-item"
                                            onMouseDown={() => handleSeleccionarSolicitante(opc)}
                                        >
                                            <strong>{opc.etiqueta}</strong>
                                            <span style={{ fontSize: '11px', color: '#666', marginLeft: '10px' }}>
                                                ({opc.valor})
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>

                {/* 2. TIPO DE SOLICITUD */}
                <div className="main-card">
                    <div className="card-header-internal" style={{ color: '#003366' }}>
                        2. Tipo de Solicitud (Marcar con X)
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '15px' }}>
                        {TIPOS_SOLICITUD.map(t => (
                            <label 
                                key={t.id} 
                                className="hab-item" 
                                style={{ 
                                    padding: '12px', 
                                    cursor: 'pointer',
                                    border: tipoSolicitud === t.id ? '2px solid #003366' : '1px solid #ddd',
                                    backgroundColor: tipoSolicitud === t.id ? '#e3f2fd' : '#fff'
                                }}
                            >
                                <input 
                                    type="radio" 
                                    name="tipoSolicitud" 
                                    checked={tipoSolicitud === t.id} 
                                    onChange={() => setTipoSolicitud(t.id)} 
                                />
                                <strong style={{ fontSize: '12px', color: '#003366' }}>{t.label}</strong>
                            </label>
                        ))}
                    </div>
                </div>

                {/* 3. DETALLES DEL MATERIAL */}
                <div className="main-card">
                    <div className="card-header-internal" style={{ color: '#003366' }}>
                        3. Detalles del Material
                    </div>
                    <table className="table">
                        <thead>
                            <tr className="table-header">
                                <th className="th" style={{ width: '15%' }}>Artículo</th>
                                <th className="th" style={{ width: '40%' }}>Descripción / Especificaciones del Material *</th>
                                <th className="th" style={{ width: '15%' }}>Cantidad *</th>
                                <th className="th" style={{ width: '20%' }}>Nº Orden Trabajo (OT)</th>
                                <th className="th" style={{ width: '20%' }}>Planta / Destino</th>
                                <th className="th" style={{ width: '5%', textAlign: 'center' }}>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {materiales.map((m, idx) => (
                                <tr key={idx}>
                                    <td className="td">
                                        <input 
                                            type="text"
                                            className="borderless-input"
                                            placeholder="Ej: ART-1024"
                                            value={m.articulo || ''}
                                            onChange={e => handleMaterialChange(idx, 'articulo', e.target.value)}
                                        />
                                    </td>
                                    <td className="td">
                                        <input 
                                            type="text"
                                            className="borderless-input"
                                            placeholder="Ej: Rodamiento SKF 6204-2RSH"
                                            value={m.descripcion}
                                            onChange={e => handleMaterialChange(idx, 'descripcion', e.target.value)}
                                        />
                                    </td>
                                    <td className="td">
                                        <input 
                                            type="text"
                                            className="borderless-input"
                                            placeholder="Ej: 2 uds"
                                            value={m.cantidad}
                                            onChange={e => handleMaterialChange(idx, 'cantidad', e.target.value)}
                                        />
                                    </td>
                                    <td className="td">
                                        <input 
                                            type="text"
                                            className="borderless-input"
                                            placeholder="Ej: OT-10492"
                                            value={m.ot_referencia}
                                            onChange={e => handleMaterialChange(idx, 'ot_referencia', e.target.value)}
                                        />
                                    </td>
                                    <td className="td">
                                        <input 
                                            type="text"
                                            className="borderless-input"
                                            placeholder="Ej: Campo Solar Aste 1A"
                                            value={m.planta_destino}
                                            onChange={e => handleMaterialChange(idx, 'planta_destino', e.target.value)}
                                        />
                                    </td>
                                    <td className="td text-center">
                                        <button 
                                            type="button" 
                                            onClick={() => handleRemoveFila(idx)}
                                            style={{ background: 'none', border: 'none', color: '#d32f2f', cursor: 'pointer', fontWeight: 'bold' }}
                                        >
                                            ✖
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button type="button" onClick={handleAddFila} className="add-btn" style={{ backgroundColor: '#003366' }}>
                        ➕ Añadir Línea de Material
                    </button>
                </div>

                {/* 4. JUSTIFICACIÓN DE LA NECESIDAD */}
                <div className="main-card">
                    <div className="card-header-internal" style={{ color: '#003366' }}>
                        4. Justificación de la Necesidad
                    </div>
                    <span className="text-subtitle">
                        (Explicar brevemente el motivo de la compra o el trabajo específico a realizar. Obligatorio para repuestos y herramientas específicas).
                    </span>
                    <textarea 
                        rows="3"
                        className="main-textarea"
                        placeholder="Escribe aquí la justificación de la necesidad..."
                        value={justificacion}
                        onChange={e => setJustificacion(e.target.value)}
                    />
                </div>

                {/* 5. DOCUMENTOS ADJUNTOS */}
                <div className="document-section">
                    <h3 className="section-title">
                        📎 Propuestas y Documentos Adjuntos (PDF, Excel, Word, Imágenes)
                    </h3>
                    <div className="document-upload-zone mt-10">
                        <input
                            type="file"
                            accept=".pdf,.xls,.xlsx,.doc,.docx,image/*"
                            multiple
                            onChange={(e) => {
                                const files = Array.from(e.target.files);
                                setArchivosPendientes(prev => [...prev, ...files]);
                            }}
                        />
                    </div>

                    {archivosPendientes.length > 0 && (
                        <div className="document-list">
                            {archivosPendientes.map((file, index) => (
                                <div key={index} className="document-item document-item-pending">
                                    <div className="document-info">
                                        <span className="document-icon">⏳</span>
                                        <span>{file.name} <em className="text-pending-status">({(file.size / 1024 / 1024).toFixed(2)} MB)</em></span>
                                    </div>
                                    <button type="button" onClick={() => setArchivosPendientes(prev => prev.filter((_, i) => i !== index))} className="btn-delete-file">
                                        X Quitar
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </form>

            {/* Modal de Firma Digital */}
            {showSignaturePad && (
                <SignaturePad 
                    onSave={(firmaBase64) => {
                        setShowSignaturePad(false);
                        procesarGuardado(firmaBase64);
                    }} 
                    onCancel={() => setShowSignaturePad(false)} 
                />
            )}
        </div>
    );
};

export default CreateCompraScreen;